import { Component } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import es from "date-fns/locale/es"; // the locale you want
import ParametroIngresoSolicitud from "../../../Contenedores/Padron/ParametroIngresoSolicitud";
import ServicioSolicitudPadron from "../../../servicios/SolicitudDePadron";
import { TIPO_SOLICITUD_INCLUSION } from "../../../Contenedores/Comun/VARIABLES";
import { Notificar } from "../../Comunes/Notificador";
import InputMask from "react-input-mask";
import {
  __MaximoCaracteresIdentificacion,
  __ObtengaClasePersona,
} from "../../../Utils/Funciones";
import DocumentosSolicitud from "../../Comunes/Documentos/DocumentosSolicitud";
import TipoPersonaDropdown from "../../Comunes/Dropdowns/TiposPersona/TipoPersonaDropdown";
import PaisesDropdown from "../../Comunes/Dropdowns/Paises/PaisesDropdown";
import GenerosDropdown from "../../Comunes/Dropdowns/Generos/GenerosDropdown";
import StickyTopBox from "../../Comunes/StickyBox/StickyTopBox";
import TextareaAutoajustable from "../../Comunes/TextareaAutoajustable/TextareaAutoajustable";
import FormatosDeIdentificaciones from "./FormatosDeIdentificaciones";
import NotaEliminacionAcentos from "../Comunes/NotaEliminacionAcentos";

registerLocale("es", es);

export class Inclusion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Archivos: [],
      identificacion: "",
      seleccionTipoPersona: "1",
      seleccionGenero: 0,
      seleccionPais: "0",
      fechaNacimiento: null,
      primerApellido: "",
      segundoApellido: "",
      nombreORazonSocial: "",
      documento: "",
      TipoPersonaFisica: true,
      MaximoCaracteres: 9,
    };

    this._guardarInclusion = this._guardarInclusion.bind(this);
    this._onSelectGenero = this._onSelectGenero.bind(this);
    this._onSelectPais = this._onSelectPais.bind(this);
    this._fechaSeleccionada = this._fechaSeleccionada.bind(this);
    this._onSelectTiposPersona = this._onSelectTiposPersona.bind(this);
    this._ObtengaIdentificacion = this._ObtengaIdentificacion.bind(this);
  }

  async ReiniciarEstados() {
    this.setState({
      Archivos: [],
      identificacion: "",
      ListaTiposDocumentos: [],
      seleccionTipoPersona: "1",
      seleccionGenero: 0,
      seleccionPais: "0",
      fechaNacimiento: null,
      primerApellido: "",
      segundoApellido: "",
      nombreORazonSocial: "",
      documento: "",
      TipoPersonaFisica: true,
      MaximoCaracteres: 9,
    });
    document.getElementById("PrimerApellido").value = "";
    document.getElementById("SegundoApellido").value = "";
    document.getElementById("NombreORazonSocial").value = "";

    this.limpiarDocumentos();
  }

  async _onSelectTiposPersona(e) {
    let valor = e.target.value;
    let max = await __MaximoCaracteresIdentificacion(valor);
    let TipoPersonaFisica = __ObtengaClasePersona(valor) === "F";
    this.setState({
      MaximoCaracteres: max,
      MostrarInformacion: false,
      TipoPersonaFisica: TipoPersonaFisica,
      seleccionTipoPersona: valor,
    });
  }

  async _onSelectPais(e) {
    this.setState({
      seleccionPais: e.target.value,
    });
  }

  async _onSelectGenero(e) {
    this.setState({
      seleccionGenero: e.target.value,
    });
  }

  async _fechaSeleccionada(date) {
    this.setState({
      fechaNacimiento: date,
    });
  }

  async _ObtengaIdentificacion({ target: { value } }) {
    value = value.replace(/\s/g, "");

    this.setState({
      identificacion: value,
    });
  }

  async _guardarInclusion() {
    let segundoApellido = document.getElementById("SegundoApellido").value;
    let parametro = new ParametroIngresoSolicitud();
    parametro.IdentificacionPersona =
      document.getElementById("Identificacion").value;
    parametro.TipoPersona = this.state.seleccionTipoPersona;
    parametro.NombreORazonSocial =
      document.getElementById("NombreORazonSocial").value;
    if (this.state.TipoPersonaFisica) {
      parametro.PrimerApellido =
        document.getElementById("PrimerApellido").value;
      parametro.SegundoApellido =
        segundoApellido === "" ? null : segundoApellido;
      parametro.Genero = this.state.seleccionGenero;
    }
    parametro.FechaConstitucionONacimiento = this.state.fechaNacimiento;
    parametro.PaisRegistroONacimiento =
      this.state.seleccionPais === "0" ? null : this.state.seleccionPais;
    parametro.TipoSolicitud = TIPO_SOLICITUD_INCLUSION;
    parametro.ListaDocumentos = this.state.Archivos;
    parametro.FechaTramite = new Date();
    var ingresarInclusion =
      await ServicioSolicitudPadron.IngresarSolicitudDePadron(parametro);

    if (ingresarInclusion.esValido) {
      await this.ReiniciarEstados();
      Notificar("success", ingresarInclusion.mensaje);
    } else {
      Notificar("error", ingresarInclusion.errores);
    }
  }

  async maskbuilder(v) {
    let digitos = !v ? "" : v.replace(/[^\d]/g, "");
    if (digitos.length > this.state.MaximoCaracteres) {
      digitos = v.substring(0, this.state.MaximoCaracteres);
      this.setState({ identificacion: digitos });
    }
    return digitos;
  }

  obtenerDocumentos = (documentos) => {
    this.setState({ Archivos: documentos });
  };

  limpiarDocumentos = () => {};

  asignarFuncionLimpiarDocumentos = (funcionLimpiarDocumentos) => {
    this.limpiarDocumentos = funcionLimpiarDocumentos;
  };

  render() {
    return (
      <div>
        <StickyTopBox>
          <div className="row">
            <div className="col">
              <h1 className="h3 mb-0 text-gray-800">
                Solicitud de inclusión al padrón
              </h1>
            </div>
            <div className="col text-right">
              <button
                onClick={this._guardarInclusion}
                className="btn btn-success btn-icon-split mr-3"
              >
                <span className="icon text-white-50">
                  <i className="far fa-check-circle"></i>
                </span>
                <span className="text">Guardar solicitud</span>
              </button>
            </div>
          </div>
        </StickyTopBox>

        <div className="card shadow mb-4">
          <div className="card-header">
            <h6 className="m-0 font-weight-bold text-primary">
              Datos de la Persona
            </h6>
          </div>
          <div className="card-body">
            <div className="form-group row">
              <div className="col-md-3 col-form-label">
                <label htmlFor="TiposPersona"> Tipo Persona</label>
              </div>
              <div className="col-md-9">
                <TipoPersonaDropdown
                  id="TiposPersona"
                  className="form-control"
                  value={this.state.seleccionTipoPersona}
                  onChange={(e) => this._onSelectTiposPersona(e)}
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-md-3">
                <label htmlFor="Identificacion" className="col-form-label mr-1">
                  Identificación
                </label>
                <FormatosDeIdentificaciones />
              </div>
              <div className="col-md-9">
                <InputMask
                  mask={this.maskbuilder(this.state.identificacion)}
                  maskChar=""
                  value={this.state.identificacion}
                  id="Identificacion"
                  className="form-control"
                  style={{
                    textTransform: "uppercase",
                  }}
                  onChange={this._ObtengaIdentificacion}
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-md-3">
                <label htmlFor="NombreORazonSocial" className="col-form-label">
                  {this.state.TipoPersonaFisica ? "Nombre" : "Razón Social"}
                </label>
              </div>
              <div className="col-md-9">
                <TextareaAutoajustable
                  className="form-control"
                  id="NombreORazonSocial"
                  defaultValue={this.state.nombreORazonSocial}
                  style={{
                    textTransform: "uppercase",
                  }}
                  maxLength={255}
                />
                <NotaEliminacionAcentos />
              </div>
            </div>

            <div
              className="form-group row"
              style={{
                display: this.state.TipoPersonaFisica ? "" : "none",
              }}
            >
              <div className="col-md-3">
                <label htmlFor="PrimerApellido" className="col-form-label">
                  Primer Apellido
                </label>
              </div>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control"
                  id="PrimerApellido"
                  defaultValue={this.state.nombreORazonSocial}
                  style={{ textTransform: "uppercase" }}
                />
                <NotaEliminacionAcentos />
              </div>
            </div>

            <div
              className="form-group row"
              style={{
                display: this.state.TipoPersonaFisica ? "" : "none",
              }}
            >
              <div className="col-md-3">
                <label htmlFor="SegundoApellido" className="col-form-label">
                  Segundo Apellido
                </label>
              </div>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control"
                  id="SegundoApellido"
                  defaultValue={this.state.nombreORazonSocial}
                  style={{ textTransform: "uppercase" }}
                />
                <NotaEliminacionAcentos />
              </div>
            </div>

            <div className="form-group row">
              <div className="col-md-3">
                <label
                  htmlFor="FechaConstitucionONacimiento"
                  className="col-form-label"
                >
                  Fecha{" "}
                  {this.state.TipoPersonaFisica ? "Nacimiento" : "Constitución"}
                </label>
              </div>
              <div className="col-md-9">
                <DatePicker
                  id="FechaConstitucionONacimiento"
                  locale="es"
                  selected={this.state.fechaNacimiento}
                  onChange={this._fechaSeleccionada}
                  dateFormat="dd/MM/yyyy"
                  className="form-control"
                />
              </div>
            </div>

            <div className="form-group row">
              <div className="col-md-3">
                <label htmlFor="Pais" className="col-form-label">
                  País de{" "}
                  {this.state.TipoPersonaFisica ? "Nacimiento" : "Constitución"}
                </label>
              </div>
              <div className="col-md-9">
                <PaisesDropdown
                  id="Pais"
                  value={this.state.seleccionPais}
                  onChange={(e) => this._onSelectPais(e)}
                />
              </div>
            </div>

            <div
              className="form-group row"
              style={{
                display: this.state.TipoPersonaFisica ? "" : "none",
              }}
            >
              <div className="col-md-3">
                <label htmlFor="Genero" className="col-form-label">
                  Género
                </label>
              </div>
              <div className="col-md-9">
                <GenerosDropdown
                  id="Genero"
                  className="form-control"
                  value={this.state.seleccionGenero}
                  onChange={(e) => this._onSelectGenero(e)}
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <DocumentosSolicitud
            onChangeDocumentos={this.obtenerDocumentos}
            pasarFuncionLimpiarState={this.asignarFuncionLimpiarDocumentos}
          />
        </div>
      </div>
    );
  }
}
